/*
 * Created with vue 2
 * Author: Jay/jaytanweb@163.com
 * Date: 2018/4/12
 * Time: 14:19
 */
<template>
  <div id='navBar' class="navBar">
    <div class="wrap">
      <div class="new-group">
        <div class="box">
          <a href="https://www.facebook.com/sangokushiM/" class="link-fb"></a>
          <div class="share-group" :class="{ 'share-group-active': ifShow }">
            <a class="twitter" @click="shareTwitter()"></a>
            <a class="kakao" @click="shareKakao()"></a>
            <a class="fb" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fsangokushi.bbgamekr.com%2Fevent&src=sdkpreparse" target="_blank"></a>
          </div>
          <a class="link-show-share" @touchstart="toggleShareGroup"></a>
          <!--<a href="javascript:void(0)" class="link-tips"></a>-->
        </div>
      </div>
      <div class="left-group">
        <a class="fb" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fsangokushi.bbgamekr.com%2Fevent&src=sdkpreparse" target="_blank"></a>
        <a class="kakao" @click="shareKakao()"></a>
        <a class="twitter" @click="shareTwitter()"></a>
      </div>
      <div class="right-group">
        <a class="download" @mouseenter.stop="toggleDownload('enter')"></a>
        <a href="https://www.facebook.com/sangokushiM/" class="fb"></a>
        <a href="http://cafe.naver.com/sam2018" class="coffee"></a>
      </div>
      <div class="download-group" :class="{'download-group-visible': downloadVisible}" @mouseleave.stop="toggleDownload('leave')">
        <a class="GooglePlay" target="_blank" href="https://play.google.com/store/apps/details?id=com.aligames.sgzhg.google"></a>
        <a class="AppStore" target="_blank" href="http://itunes.apple.com/KR/app/id1353267865?mt=8"></a>
        <a class="OneStore" target="_blank" href="http://m.onestore.co.kr/mobilepoc/apps/appsDetail.omp?prodId=0000726276"></a>
        <a class="GalaxyApps" target="_blank" href="http://apps.samsung.com/appquery/appDetail.as?appId=com.aligames.sgzhg.samsung"></a>
      </div>
      <div class="guide">
        <span class="guide1" :class="{ 'guide1-active': guideInside[0] }" @click="fullpageChangeTo(1)"><div class="guide-inside"><a></a></div></span>
        <span class="guide2" :class="{ 'guide2-active': guideInside[1] }" @click="fullpageChangeTo(2)"><div class="guide-inside"><a></a></div></span>
        <span class="guide3" :class="{ 'guide3-active': guideInside[2] }" @click="fullpageChangeTo(3)"><div class="guide-inside"><a></a></div></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'navBar',
  props: {
    makeItLight: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      ifShow: false,
      downloadVisible: false,
      guideInside: [true, false, false]
    }
  },
  watch: {
    makeItLight (n, o) {
      console.log('页面发生了改变，正展示页面：', n)
      let arrTmp = this.guideInside.map((arr, index) => {
        return (arr = index === n)
      })
      this.guideInside = arrTmp
      console.log('forEach 结果', this.guideInside)
    }
  },
  components: {

  },
  methods: {
    ...mapMutations({
      alert: 'clickBtn'
    }),
    notReady () {
      this.alert(['기대해주세요'])
    },
    toggleDownload (type) {
      console.log('found', type)
      switch (type) {
        case 'enter':
          this.downloadVisible = true
          break
        case 'leave':
          this.downloadVisible = false
          break
      }
    },
    fullpageChangeTo (id) {
      this.$emit('fullpageChange', id)
    },
    toggleShareGroup () {
      this.ifShow = this.ifShow === false
    },
    shareTwitter () {
      let twTitle = '전설의 귀환-전란을 끝낼 시간이 왔다！코에이 테크모에서 정품인증한 <신삼국지 모바일>사전예약 절찬 진행중！'
      // let twTitle = ''
      let twUrl = 'https://sangokushi.bbgamekr.com'
      // let twUrl = ''
      window.open('http://twitter.com/home/?status='.concat(encodeURIComponent(twTitle)).concat(' ').concat(encodeURIComponent(twUrl)))
    },
    shareKakao () {
      // eslint-disable-next-line
      Kakao.Story.share({
        url: 'https://sangokushi.bbgamekr.com/',
        text: '친구들과 함께 즐기자~ 카카오스토리 공유하고 푸짐한 상품받으세요~!'
      })
    }
  },
  mounted: function () {
    // navBar mounted
    this.$lib.addC4M('navBar', 'navBar-mb')
    this.$lib.addC4iPad('navBar', 'navBar-iPad')
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.navBar {
  //begin you code
  z-index: 3;
  width: 100%;
  height: 50px;
  position: absolute;
  top: 0;
  left: 0;
  background: url("../assets/images/index/header/nav-bg.jpg") center top no-repeat;
  background-size: cover;
  .wrap {
    position: relative;
    width: 60%;
    min-width: 760px;
    height: 100%;
    margin: auto;
    .new-group {
      display: none;
    }
    .left-group {
      position: relative;
      float: left;
      height: 100%;
      margin-left: -100px;
      a {
        position: relative;
        float: left;
        display: block;
        width: 40px;
        height: 40px;
        top: 50%;
        transform: translateY(-50%);
        transition: all 0.7s;
        cursor: pointer;
      }
      .fb {
        background: url("../assets/images/index/header/share-fb.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index/header/share-fb-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
      .kakao {
        background: url("../assets/images/index/header/share-kakao.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index/header/share-kakao-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
      .twitter {
        background: url("../assets/images/index/header/share-twitter.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index/header/share-twitter-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
    }
    .right-group {
      position: relative;
      float: right;
      height: 100%;
      margin-right: -50px;
      a {
        position: relative;
        float: left;
        display: block;
        width: 40px;
        height: 40px;
        top: 50%;
        transform: translateY(-50%);
        transition: all 0.7s;
      }
      .download {
        cursor: pointer;
        background: url("../assets/images/index/download/download-icon.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index/download/download-icon-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
      .fb {
        background: url("../assets/images/index/header/fb.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index/header/fb-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
      .coffee {
        background: url("../assets/images/index/header/coffee.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index/header/coffee-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
    }
    .download-group {
      opacity: 0;
      pointer-events: none;
      transition: all .8s;
      position: absolute;
      top: 70px;
      right: -73px;
      padding: 15px;
      background: rgba(0,0,0,.85);
      a {
        display: block;
        width: 205px;
        height: 45px;
        margin-bottom: 10px;
        opacity: .5;
        transition: opacity .5s;
        cursor: pointer;
        &:last-of-type {
          margin-bottom: 0;
        }
        &:hover {
          opacity: 1;
        }
        &:active {
          opacity: 1;
        }
      }
      .GooglePlay {
        background: url("../assets/images/index/download/download-icon01.png") center top no-repeat;
        background-size: contain;
      }
      .AppStore {
        background: url("../assets/images/index/download/download-icon02.png") center top no-repeat;
        background-size: contain;
      }
      .OneStore {
        background: url("../assets/images/index/download/download-icon03.png") center top no-repeat;
        background-size: contain;
      }
      .GalaxyApps {
        background: url("../assets/images/index/download/download-icon04.png") center top no-repeat;
        background-size: contain;
      }
    }
    .download-group-visible {
      opacity: 1;
      pointer-events: auto;
    }
    .guide {
      max-width: 500px;
      height: 100%;
      margin: auto;
      position: relative;
      span {
        cursor: pointer;
      }
      .guide1 {
        width: 100px;
        height: 100%;
        position: absolute;
        left: -50px;
        top: 50%;
        transform: translateY(-50%);
        background: url("../assets/images/index/header/01.png") center no-repeat;
        background-size: contain;
        transition: all 0.7s;
        .guide-inside {
          width: 0;
          height: 100%;
          border-top: 2px solid #ffebc0;
          margin: 0 auto;
          transition: all 0.7s;
          a {
            position: absolute;
            left: 50%;
            bottom: 6px;
            transform: translateX(-50%) rotate(45deg);
            width: 0;
            height: 0;
            background: #ffebc0;
            transition: all 0.7s;
          }
        }
        &:hover {
          background: url("../assets/images/index/header/01-hover.png") center no-repeat;
          background-size: contain;
          .guide-inside {
            width: 37px;
          }
        }
      }
      .guide1-active {
        background: url("../assets/images/index/header/01-hover.png") center no-repeat;
        background-size: contain;
        .guide-inside {
          width: 37px;
          a {
            width: 5px;
            height: 5px;
          }
        }
      }
      .guide2 {
        width: 100px;
        height: 100%;
        position: absolute;
        left: 180px;
        top: 50%;
        transform: translateY(-50%);
        background: url("../assets/images/index/header/02.png") center no-repeat;
        background-size: contain;
        transition: width 0.7s;
        .guide-inside {
          width: 0;
          height: 100%;
          border-top: 2px solid #ffebc0;
          margin: 0 auto;
          transition: all 0.7s;
          a {
            position: absolute;
            left: 50%;
            bottom: 6px;
            transform: translateX(-50%) rotate(45deg);
            width: 0;
            height: 0;
            background: #ffebc0;
            transition: all 0.7s;
          }
        }
        &:hover {
          background: url("../assets/images/index/header/02-hover.png") center no-repeat;
          background-size: contain;
          .guide-inside {
            width: 77px;
          }
        }
      }
      .guide2-active {
        background: url("../assets/images/index/header/02-hover.png") center no-repeat;
        background-size: contain;
        .guide-inside {
          width: 77px;
          a {
            width: 5px;
            height: 5px;
          }
        }
      }
      .guide3 {
        width: 100px;
        height: 100%;
        position: absolute;
        left: 430px;
        top: 50%;
        transform: translateY(-50%);
        background: url("../assets/images/index/header/03.png") center no-repeat;
        background-size: contain;
        transition: width 0.7s;
        .guide-inside {
          width: 0;
          height: 100%;
          border-top: 2px solid #ffebc0;
          margin: 0 auto;
          transition: all 0.7s;
          a {
            position: absolute;
            left: 50%;
            bottom: 6px;
            transform: translateX(-50%) rotate(45deg);
            width: 0;
            height: 0;
            background: #ffebc0;
            transition: all 0.7s;
          }
        }
        &:hover {
          background: url("../assets/images/index/header/03-hover.png") center no-repeat;
          background-size: contain;
          .guide-inside {
            width: 55px;
          }
        }
      }
      .guide3-active {
        background: url("../assets/images/index/header/03-hover.png") center no-repeat;
        background-size: contain;
        .guide-inside {
          width: 55px;
          a {
            width: 5px;
            height: 5px;
          }
        }
      }
    }
  }
}
.navBar-mb {
  //begin you code
  z-index: 3;
  width: 100%;
  height: 1.00rem;
  position: absolute;
  top: 0;
  left: 0;
  background: url("../assets/images/index-mb/header/nav-bg.png") center top no-repeat;
  background-size: cover;
  .wrap {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0;
    min-width: 0;
    .new-group {
      display: block;
      position: absolute;
      right: .10rem;
      top: 10.70rem;
      width: .80rem;
      .box {
        position: absolute;
        left: 0;
        bottom: 0;
        a {
          display: block;
          width: .80rem;
          height: .80rem;
          cursor: pointer;
        }
        .link-tips {
          background: url("../assets/images/index-mb/header/link03-gotop.png") center top no-repeat;
          background-size: contain;
        }
        .link-fb {
          background: url("../assets/images/index-mb/header/link01.png") center top no-repeat;
          background-size: contain;
        }
        .link-show-share {
          background: url("../assets/images/index-mb/header/link02.png") center top no-repeat;
          background-size: contain;
          &:active {
            background: url("../assets/images/index-mb/header/link02-hover.png") center top no-repeat;
            background-size: contain;
          }
        }
        .share-group {
          a {
            display: block;
            width: .80rem;
            height: 0;
            opacity: 0;
            transform: rotate3d(1, 1, 1, 0deg);
            transition: .5s;
            cursor: pointer;
          }
          .twitter {
            background: url("../assets/images/index-mb/header/share01.png") center top no-repeat;
            background-size: contain;
          }
          .kakao {
            background: url("../assets/images/index-mb/header/share02.png") center top no-repeat;
            background-size: contain;
          }
          .fb {
            background: url("../assets/images/index-mb/header/share03.png") center top no-repeat;
            background-size: contain;
          }
        }
        .share-group-active {
          a {
            height: .80rem;
            opacity: 1;
            transform: rotate3d(0, 0, 1, 360deg);
          }
        }
      }
    }
    .left-group {
      display: none;
    }
    .right-group {
      position: relative;
      float: right;
      height: 100%;
      margin-right: .24rem;
      a {
        position: relative;
        float: left;
        display: block;
        width: .80rem;
        height: 1.00rem;
        top: 0;
        transform: none;
        transition: all 0.7s;
      }
      .download {
        display: none;
      }
      .fb {
        display: none;
      }
      .coffee {
        background: url("../assets/images/index-mb/header/coffee.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index-mb/header/coffee.png") center top no-repeat;
          background-size: contain;
        }
      }
    }
    .download-group {
      display: none;
    }
    .guide {
      max-width: 5.30rem;
      height: 100%;
      margin: 0;
      position: relative;
      span {
        cursor: pointer;
      }
      .guide1 {
        width: 2.00rem;
        height: 1.00rem;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: url("../assets/images/index-mb/header/01.png") center top no-repeat;
        background-size: contain;
        .guide-inside {
          width: 0;
          height: 100%;
          border-top: .02rem solid #ffebc0;
          margin: 0 auto;
          transition: all 0.7s;
          a {
            position: absolute;
            left: 50%;
            bottom: .06rem;
            transform: translateX(-50%) rotate(45deg);
            width: 0;
            height: 0;
            background: #ffebc0;
            transition: all 0.7s;
          }
        }
        &:hover {
          background: url("../assets/images/index-mb/header/01-hover.png") center top no-repeat;
          background-size: contain;
          .guide-inside {
            width: .60rem;
          }
        }
      }
      .guide1-active {
        background: url("../assets/images/index-mb/header/01-hover.png") center no-repeat;
        background-size: contain;
        .guide-inside {
          width: .60rem;
          a {
            width: .05rem;
            height: .05rem;
          }
        }
      }
      .guide2 {
        width: 2.00rem;
        height: 1.00rem;
        position: absolute;
        left: 2.17rem;
        top: 50%;
        transform: translateY(-50%);
        background: url("../assets/images/index-mb/header/02.png") center top no-repeat;
        background-size: contain;
        .guide-inside {
          width: 0;
          height: 100%;
          border-top: .02rem solid #ffebc0;
          margin: 0 auto;
          transition: all 0.7s;
          a {
            position: absolute;
            left: 50%;
            bottom: .06rem;
            transform: translateX(-50%) rotate(45deg);
            width: 0;
            height: 0;
            background: #ffebc0;
            transition: all 0.7s;
          }
        }
        &:hover {
          background: url("../assets/images/index-mb/header/02-hover.png") center no-repeat;
          background-size: contain;
          .guide-inside {
            width: 1.20rem;
          }
        }
      }
      .guide2-active {
        background: url("../assets/images/index-mb/header/02-hover.png") center no-repeat;
        background-size: contain;
        .guide-inside {
          width: 1.20rem;
          a {
            width: .05rem;
            height: .05rem;
          }
        }
      }
      .guide3 {
        width: 2.00rem;
        height: 1.00rem;
        position: absolute;
        left: 4.42rem;
        top: 50%;
        transform: translateY(-50%);
        background: url("../assets/images/index-mb/header/03.png") center top no-repeat;
        background-size: contain;
        .guide-inside {
          width: 0;
          height: 100%;
          border-top: .02rem solid #ffebc0;
          margin: 0 auto;
          transition: all 0.7s;
          a {
            position: absolute;
            left: 50%;
            bottom: .06rem;
            transform: translateX(-50%) rotate(45deg);
            width: 0;
            height: 0;
            background: #ffebc0;
            transition: all 0.7s;
          }
        }
        &:hover {
          background: url("../assets/images/index-mb/header/03-hover.png") center no-repeat;
          background-size: contain;
          .guide-inside {
            width: .85rem;
          }
        }
      }
      .guide3-active {
        background: url("../assets/images/index-mb/header/03-hover.png") center no-repeat;
        background-size: contain;
        .guide-inside {
          width: .85rem;
          a {
            width: .05rem;
            height: .05rem;
          }
        }
      }
    }
  }
}
.navBar-iPad {
  //begin you code
  z-index: 3;
  width: 100%;
  height: 1.00rem;
  position: absolute;
  top: 0;
  left: 0;
  background: url("../assets/images/index-mb/header/nav-bg.png") center top no-repeat;
  background-size: cover;
  .wrap {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0;
    min-width: 0;
    .new-group {
      display: block;
      position: absolute;
      right: .10rem;
      top: 8.5rem;
      width: .80rem;
      .box {
        position: absolute;
        left: 0;
        bottom: 0;
        a {
          display: block;
          width: .80rem;
          height: .80rem;
        }
        .link-tips {
          background: url("../assets/images/index-mb/header/link03-gotop.png") center top no-repeat;
          background-size: contain;
        }
        .link-fb {
          background: url("../assets/images/index-mb/header/link01.png") center top no-repeat;
          background-size: contain;
        }
        .link-show-share {
          background: url("../assets/images/index-mb/header/link02.png") center top no-repeat;
          background-size: contain;
          &:active {
            background: url("../assets/images/index-mb/header/link02-hover.png") center top no-repeat;
            background-size: contain;
          }
        }
        .share-group {
          a {
            display: block;
            width: .80rem;
            height: 0;
            opacity: 0;
            transform: rotate3d(1, 1, 1, 0deg);
            transition: .5s;
            cursor: pointer;
          }
          .twitter {
            background: url("../assets/images/index-mb/header/share01.png") center top no-repeat;
            background-size: contain;
          }
          .kakao {
            background: url("../assets/images/index-mb/header/share02.png") center top no-repeat;
            background-size: contain;
          }
          .fb {
            background: url("../assets/images/index-mb/header/share03.png") center top no-repeat;
            background-size: contain;
          }
        }
        .share-group-active {
          a {
            height: .80rem;
            opacity: 1;
            transform: rotate3d(0, 0, 1, 360deg);
          }
        }
      }
    }
    .left-group {
      display: none;
    }
    .right-group {
      position: relative;
      float: right;
      height: 100%;
      margin-right: .24rem;
      a {
        position: relative;
        float: left;
        display: block;
        width: .80rem;
        height: 1.00rem;
        top: 0;
        transform: none;
        transition: all 0.7s;
      }
      .download {
        display: none;
      }
      .fb {
        display: none;
      }
      .coffee {
        background: url("../assets/images/index-mb/header/coffee.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index-mb/header/coffee.png") center top no-repeat;
          background-size: contain;
        }
      }
    }
    .guide {
      max-width: 5.30rem;
      height: 100%;
      margin: 0;
      position: relative;
      span {
        cursor: pointer;
      }
      .guide1 {
        width: 2.00rem;
        height: 1.00rem;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: url("../assets/images/index-mb/header/01.png") center top no-repeat;
        background-size: contain;
        .guide-inside {
          width: 0;
          height: 100%;
          border-top: .02rem solid #ffebc0;
          margin: 0 auto;
          transition: all 0.7s;
          a {
            position: absolute;
            left: 50%;
            bottom: .06rem;
            transform: translateX(-50%) rotate(45deg);
            width: 0;
            height: 0;
            background: #ffebc0;
            transition: all 0.7s;
          }
        }
        &:hover {
          background: url("../assets/images/index-mb/header/01-hover.png") center top no-repeat;
          background-size: contain;
          .guide-inside {
            width: .60rem;
          }
        }
      }
      .guide1-active {
        background: url("../assets/images/index-mb/header/01-hover.png") center no-repeat;
        background-size: contain;
        .guide-inside {
          width: .60rem;
          a {
            width: .05rem;
            height: .05rem;
          }
        }
      }
      .guide2 {
        width: 2.00rem;
        height: 1.00rem;
        position: absolute;
        left: 2.17rem;
        top: 50%;
        transform: translateY(-50%);
        background: url("../assets/images/index-mb/header/02.png") center top no-repeat;
        background-size: contain;
        .guide-inside {
          width: 0;
          height: 100%;
          border-top: .02rem solid #ffebc0;
          margin: 0 auto;
          transition: all 0.7s;
          a {
            position: absolute;
            left: 50%;
            bottom: .06rem;
            transform: translateX(-50%) rotate(45deg);
            width: 0;
            height: 0;
            background: #ffebc0;
            transition: all 0.7s;
          }
        }
        &:hover {
          background: url("../assets/images/index-mb/header/02-hover.png") center no-repeat;
          background-size: contain;
          .guide-inside {
            width: 1.20rem;
          }
        }
      }
      .guide2-active {
        background: url("../assets/images/index-mb/header/02-hover.png") center no-repeat;
        background-size: contain;
        .guide-inside {
          width: 1.20rem;
          a {
            width: .05rem;
            height: .05rem;
          }
        }
      }
      .guide3 {
        width: 2.00rem;
        height: 1.00rem;
        position: absolute;
        left: 4.42rem;
        top: 50%;
        transform: translateY(-50%);
        background: url("../assets/images/index-mb/header/03.png") center top no-repeat;
        background-size: contain;
        .guide-inside {
          width: 0;
          height: 100%;
          border-top: .02rem solid #ffebc0;
          margin: 0 auto;
          transition: all 0.7s;
          a {
            position: absolute;
            left: 50%;
            bottom: .06rem;
            transform: translateX(-50%) rotate(45deg);
            width: 0;
            height: 0;
            background: #ffebc0;
            transition: all 0.7s;
          }
        }
        &:hover {
          background: url("../assets/images/index-mb/header/03-hover.png") center no-repeat;
          background-size: contain;
          .guide-inside {
            width: .85rem;
          }
        }
      }
      .guide3-active {
        background: url("../assets/images/index-mb/header/03-hover.png") center no-repeat;
        background-size: contain;
        .guide-inside {
          width: .85rem;
          a {
            width: .05rem;
            height: .05rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/index/navBar.vue